import styled from 'styled-components';

export const StyledBlogCategoriesList = styled.ul`
  display: flex;
  flex-flow: row wrap;
  list-style-type: none;
  padding: 0;
  margin: 0;
  font-family: 'Open Sans';
  font-size: 14px;
  color: rgba(60,60,59,0.8);
  text-transform: capitalize;

  li {
    line-height: normal;
    margin-right: 15px;
    margin-bottom: 8px;

    a {
      color: #4990e2;
    }
  }

  @media (min-width: 1024px) {
    flex-flow: nowrap;
    flex-direction: column;
    li {
      margin-right: 0px;
      margin-bottom: 5px;
    }
  }
`

export const StyledBlogsContainer = styled.div `
  display: flex;
  width: 100%;
  margin-top: ${props => props.isFilteredView ? "40px" : props.isArticle ? "60px" : "90px"};
  flex-direction: column;

  @media (min-width: 1024px) {
    flex-direction: row;
    justify-content: space-between;
  }
`

export const StyledBlogsLargeColumnWrapper = styled.div `
  width: 100%;

  @media(min-width: 768px) {
    width: 80%;
  }
  
  @media (min-width: 1024px) {
    width: 70%;
  }
`

export const StyledBlogsSmallColumnWrapper = styled.div `
  width: 100%;
  margin-bottom: 50px;
  
  @media (min-width: 1024px) {
    width: 30%;
    margin-left: 90px;
  }
  
  @media (min-width: 1100px) { 
    margin-left: 150px;
  }
`

export const StyledBlogSmallHeading = styled.div `
  color: #636463;
  font-size: 0.75em;
  font-weight: 600;
  letter-spacing: 0.93px;
  text-transform: uppercase;
`

export const StyledLoadMoreButtonWrapper = styled.div `
  display: flex;
  justify-content: center;
  margin-top: 20px;
  margin-bottom: 20px;
  padding-bottom: 50px;
  border-bottom: 1px solid #D4D6DE;
  
  @media (min-width: 768px) {
    justify-content: left;
    margin-top: 0px;
    margin-bottom: 50px;
    padding-bottom: 0px;
    border-bottom: none;
  }
`